import React, {useEffect, useRef,} from 'react';
import {usePage} from '@inertiajs/react';
import {Toast} from "primereact/toast";
import {useAppContext} from "@Utils/AppProvider";

export default function ToastWrap() {
  const toast = useRef<Toast>(null);
  const {toastData, showToast} = useAppContext() as any;
  const { props: inertiaProps } = usePage<any>();
  const { errors, flash } = inertiaProps;
  const renderHtmlMessage = (message: string) => `${message}`;

  // Call from context
  useEffect(() => {
    if (!toastData) {
      return;
    }
    const timeout = setTimeout(() => {
      const toastParams = {
        severity: 'info',
        summary: '',
        detail: <b>Something went wrong</b>,
        life: 8000,
      }

      if (toastData.errors && Object.keys(toastData.errors).length > 0) {
        toastParams.severity = 'error';
        toastParams.summary = toastData.summary ?? 'Something went wrong';
        toastParams.detail = (
          <ul className="m-0 p-0 mt-4">
            {Object.keys(toastData.errors).map((field) => (
              <li key={field} className="mt-2">
                {toastData.errors?.[field]}
              </li>
            ))}
          </ul>
        );
      } else if (toastData.message) {
        toastParams.severity = 'success';
        toastParams.summary = 'Success';
        toastParams.detail = (
          <div
            dangerouslySetInnerHTML={{
              __html: toastData.message,
            }}
          />
        );
      }

      toast.current?.show(toastParams as any);
      showToast(null);
    }, 100);
    return () => clearTimeout(timeout);
  }, [toastData, showToast]);

  useEffect(() => {
    if (!flash.message) {
      return;
    }
    if (flash.message) {
      const toastParams = {
        severity: 'success',
        summary: 'Success',
        detail: (
          <div
            dangerouslySetInnerHTML={{
              __html: renderHtmlMessage(flash.message),
            }}
          />
        ),
        life: 8000,
      }
      toast.current?.show(toastParams as any);

      flash.message = null;
    }
  }, [flash.message]);

  // Call from errors/flash.errors
  useEffect(() => {
    // Build error list from either object (`errors`) or string (`flash.error`)
    const errorList = errors && Object.keys(errors).length > 0
      ? Object.values(errors)
      : flash.error
        ? [flash.error]
        : [];

    if (!errorList.length) {
      return;
    }

    const toastParams = {
      severity: 'error',
      summary: 'Something went wrong',
      detail: (
        <ul className="m-0 p-0 mt-4">
          {errorList.map((err, idx) => (
            <li key={idx} className="mt-2">{err}</li>
          ))}
        </ul>
      ),
      life: 8000,
    }
    toast.current?.show(toastParams as any);

    // Clear flash error after showing
    if (flash.error) {
      flash.error = null;
    }
  }, [errors, flash.error]);

  return  <Toast ref={toast} position="bottom-left" />

}
